// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'

/* swiper */
import 'swiper/dist/css/swiper.min.css'

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'

/* 头部组件 */
import Header from './components/Header'
/* 尾部组件 */
import Footer from './components/Footer'
/* 回到顶部 */
import GoTop from './components/GoTop'
// 侧边组件
import RightNav from './components/RightNav'
// 弹窗
import PopupWindow from './components/PopupWindow.vue'
// 表单组件
import iView from 'iview'
import 'iview/dist/styles/iview.css'


Vue.use(iView);

Vue.component(Header.name, Header);

Vue.component(Footer.name, Footer);

Vue.component(GoTop.name, GoTop);

Vue.component(RightNav.name, RightNav);

Vue.component(PopupWindow.name, PopupWindow);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js